import {useEffect, useState} from 'react'
import {useI18n} from 'store/Store'

const useDancesList = ({searchResults, onSelectValue, setInputValue}) => {
    const {i18n} = useI18n()
    const [status, setStatus] = useState(null)

    const results = searchResults?.data ?? []

    const getOptionLabel = ({
        _id,
        nameEng,
        nameHeb,
        choreographersDisplayEng,
    }) => {
        const parts = [_id, nameEng, nameHeb, choreographersDisplayEng].filter(
            Boolean
        )
        return parts.join(' | ')
    }

    const getDanceName = (dance) => {
        return dance?.nameHeb || dance?.nameEng || dance?._id || 'dance'
    }

    const handleSelectDance = (dance) => {
        if (!dance || !onSelectValue) return

        const result = onSelectValue(dance)
        const danceName = getDanceName(dance)

        if (result?.added) {
            setStatus({
                type: 'success',
                message: i18n.t('danceCollections.statusAdded', {
                    name: danceName,
                }),
            })
            setInputValue?.('')
        } else if (result?.reason === 'duplicate') {
            setStatus({
                type: 'info',
                message: i18n.t('danceCollections.statusDuplicate', {
                    name: danceName,
                }),
            })
        }
    }

    const dismissStatusMessage = () => {
        const timeout = setTimeout(() => setStatus(null), 4000)
        return () => clearTimeout(timeout)
    }

    useEffect(() => {
        if (!status) return

        return dismissStatusMessage()
    }, [status, setStatus])

    return {results, getOptionLabel, status, setStatus, handleSelectDance}
}

export default useDancesList
